
import { Options, Vue } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { RemoteMonitoringRecord } from '@/api/models/RemoteMonitoringRecord';
import { NDateTimeLabel, NHint, NTag } from '@/uikit';

@Options({
  name: 'CardMonitoringStatus',
  components: { NDateTimeLabel, NHint, NTag }
})
export default class CardMonitoringStatus extends Vue {
  @Prop({ type: Object, required: true })
  readonly item!: RemoteMonitoringRecord;
}
